// Утилиты для работы с налоговыми системами

export type TaxSystemEn = 'OSNO' | 'USN' | 'ESHN' | 'PSN' | 'NPD' | 'AUSN'
export type TaxSystemRu = 'ОСНО' | 'УСН' | 'ЕСХН' | 'ПСН' | 'НПД' | 'АУСН'

// Преобразование английского названия в русское
export function getTaxSystemLabel(taxSystem: string): string {
  const mapping: Record<string, string> = {
    OSNO: 'ОСНО',
    USN: 'УСН',
    ESHN: 'ЕСХН',
    PSN: 'ПСН',
    NPD: 'НПД',
    AUSN: 'АУСН'
  }

  return mapping[taxSystem] || taxSystem
}

// Преобразование русского названия в английское (для фильтров)
export function getTaxSystemValue(taxSystemRu: string): string {
  const mapping: Record<string, string> = {
    ОСНО: 'OSNO',
    УСН: 'USN',
    ЕСХН: 'ESHN',
    ПСН: 'PSN',
    НПД: 'NPD',
    АУСН: 'AUSN'
  }

  return mapping[taxSystemRu] || taxSystemRu
}

// Получить отображаемое название с учетом ставки УСН
export function getDisplayTaxSystem(taxSystem: string, usnRate?: number): string {
  const label = getTaxSystemLabel(taxSystem)

  if (label === 'УСН' && usnRate) {
    return `УСН ${usnRate}%`
  }

  return label
}
